import React, { useState, useRef } from 'react'
import Video from '../video/video';
import Audio from '../audio/audio';
import "./securityroom.css";
import styled, { keyframes } from 'styled-components';
import { fadeIn } from 'react-animations';


const Animation = keyframes`${fadeIn}`;

const FadeinDiv = styled.div`
  animation: 10s ${Animation};
`;

const SecurityRoom = (props) => {

    const playVideo = useRef(null);

    const actorName = "JOE";
    const actorTitle = "Security Guard";
    //const posterURL = './actors/JOE.png';

    const posterURL = './bgs/SecurityBG.jpg';
    const introURL = './videos/3_1_Joe_Requests_Confirmation.mp4';

    const [currentVideoURL, setCurrentVideoURL] = useState(introURL)

    const [enableButton, setEnableButton] = useState(false);

    const confirmVideoURL = './videos/3_1_Confirmation.mp4';

    const promptVideos = ['./videos/CNE-02-Confirmation-Prompts_Extended_Oct7.mp4', './videos/CNE-02-Confirmation-Prompts_Extended_Oct7.mp4', './videos/CNE-02-Confirmation-Prompts_Extended_Oct7.mp4'];

    let btnRef = useRef();

    const updateVideoStatue = (value, src) => {
        // console.log("update video playing Status", value, src);
        if (value === "ended") {
            if (currentVideoURL === confirmVideoURL) {
                props.goToStep(null, 'FoodPuzzle');
            } else if (currentVideoURL === introURL) {
                showConfirmationButton();
                loopVideos(src);
            } else if (promptVideos.includes(currentVideoURL)) {
                loopVideos(src);
            } else {
                loopVideos(src);
            }
        }

    }
    const showConfirmationButton = () => {
        setEnableButton(true);
    }
    const loopVideos = () => {

        if (currentVideoURL === null || currentVideoURL === introURL) {
            setCurrentVideoURL(promptVideos[0]);
            playVideo.current(promptVideos[0]);
            return;
        }

        if (currentVideoURL === promptVideos[0]) {

            setCurrentVideoURL(promptVideos[1]);
            playVideo.current(promptVideos[1]);
        } else if (currentVideoURL === promptVideos[1]) {

            setCurrentVideoURL(promptVideos[2]);
            playVideo.current(promptVideos[2]);
        } else if (currentVideoURL === promptVideos[2]) {

            setCurrentVideoURL(promptVideos[0]);
            playVideo.current(promptVideos[0]);
        } else {

            setCurrentVideoURL(promptVideos[0]);
            playVideo.current(promptVideos[0]);
        }

    }

    const eventHandler = (event) => {
        if (btnRef.current) {
            btnRef.current.setAttribute("disabled", "disabled");
        }
        playVideo.current(confirmVideoURL);
        setCurrentVideoURL(confirmVideoURL);
    }

    return (
        <div className="SecurityRoom">
            <FadeinDiv>
                <div className="folderContainer">

                    <div className='folder'></div>
                    <div className='prizesContainer'>
                        <div className='prize1'></div>
                        <div className='prize2'></div>
                        <div className='prize3'></div>
                    </div>

                    <div className='whiteNote'>
                        <div className='instructionNote'>
                            Paranormal Investigator, we need your help to find the missing plushies, but you only have <u><b>30 minutes</b></u> to find all of them. Press the Start Game button if you are up for the challenge!
                        </div>
                        <div className='hintNote'>
                            Look for the “?” icon for additional clues!
                        </div>
                    </div>

                    {enableButton ? <button className='ConfirmButton' ref={btnRef} onClick={eventHandler}>Start Game</button> : <></>}

                </div>
            </FadeinDiv>
            <div className='SecuirtyVideo'>
                <Video VideoURL={introURL} actorName={actorName} actorTitle={actorTitle} poster={posterURL} updateVideoStatue={updateVideoStatue} playVideo={playVideo} />
                <Audio AudioURL="./musics/the-crackdown.mp3" ></Audio>
            </div>

        </div>

    );
}

export default SecurityRoom;